export default __webpack_public_path__ + "static/media/blueKalenday.c8b3f469.png";